import { createAction } from '@reduxjs/toolkit';

export const closeTransferWindowDrawer = createAction<void>(
  'TRANSFER_WINDOW_DRAWER/CLOSE_DRAWER'
);

export const openTransferWindowDrawer = createAction<void>(
  'TRANSFER_WINDOW_DRAWER/OPEN_DRAWER'
);
